<template>
  <v-app>
    <!--
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>
-->
    <app-header></app-header>
    <v-content style="background-color:rgba(128,128,196,0.125);">
      <router-view></router-view>
      <v-snackbar 
        v-model="feedback.snackbar" 
        :color="feedback.color" 
        :timeout="feedback.timeout"
        @input="check_input">
        {{ feedback.message }}
        <v-btn text @click="close_feedback">Close</v-btn>
      </v-snackbar>

    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
    AppHeader: () => import("@/components/Header")
  },

  data: () => ({
    //
  }),

  computed: {
    show() {

    },

    feedback() {
      return this.$store.getters['feedback/feedback']
    }
  },

  methods: {
    close_feedback() {
      this.$store.dispatch('feedback/close')
    },

    check_input($event) {
      if (!$event)
        this.close_feedback()
    }
  }
};
</script>
